import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SalesDocument, Synced } from '@icc/b2b/shared';
import { SyncService } from '../sync.service';

@Component({
    selector: 'icc-synced-indicator',
    templateUrl: './synced-indicator.component.html',
    styleUrls: ['./synced-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncedIndicatorComponent implements OnChanges {

    @Input() documents: string[] = [];
    @Input() syncedDocuments: Map<string, Synced> = new Map<string, Synced>();
    @Input() online = false;

    synced: Synced = Synced.Synced;

    constructor(private syncService: SyncService) {}

    ngOnChanges(): void {
        this.synced = this.syncService.getSynced(this.documents, this.syncedDocuments, this.online);
    }
}
